module.exports = __webpack_public_path__ + "img/recess-poster.e23a0fa2.jpg";